import {createFileRoute} from '@tanstack/react-router'
import React from "react";
import Content from "../../../components/Content.tsx";
import Header from "../../../Header.tsx";
import TournamentsRankingTablesEdit from "../../../tournaments/RankingTables/Edit.tsx";

export const Route = createFileRoute('/_app/running/leaderboards/$ranking_group_uid')({
    component:  RouteComponent,
    staticData: {
        backUrl: '/running/upload/',
    }
})

function RouteComponent() {
    return <>
        <Header backUrl={'/tournaments/'} />
        <Content>
            <TournamentsRankingTablesEdit sport_type={"running"} />
        </Content>
    </>
}
